module.exports = __webpack_public_path__ + "static/media/cr.da8b9e62.svg";